import { render, staticRenderFns } from "./ProductChecklist.vue?vue&type=template&id=74a3708d&scoped=true&"
import script from "./ProductChecklist.vue?vue&type=script&lang=js&"
export * from "./ProductChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a3708d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a3708d')) {
      api.createRecord('74a3708d', component.options)
    } else {
      api.reload('74a3708d', component.options)
    }
    module.hot.accept("./ProductChecklist.vue?vue&type=template&id=74a3708d&scoped=true&", function () {
      api.rerender('74a3708d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductChecklist.vue"
export default component.exports